import React,{useState,useRef} from "react";
import { TextField } from "@material-ui/core";
import { isNumber, isSpecial } from "../../lib/Common";

function Residence(props) {
  const classes = props.useStyles();
  const residenceRef = useRef(null);
  const [errorText, setErrorText] = useState(
    ""
  );
  const [errorValue, setErrorValue] = useState(false);
  return (
    <TextField
      className={classes.TextField}
      fullWidth
      label="주소"
      type="text"
      variant="filled"
      inputRef={residenceRef}
      error={errorValue}
      helperText={errorText}
      onBlur={(e) => {
        if ( isNumber.test(e.target.value) || isSpecial.test(e.target.value) ){
          setErrorText("한글 / 영문만 입력 가능합니다.");
          setErrorValue(true);
          residenceRef.current.focus();
        } else {
          setErrorText("");
          setErrorValue(false);
          props.onChangeResidence(e.target.value);
        }
      }}
      
      name="residence"
      defaultValue={props.residence}
    />
  );
}
export default Residence;
